module.exports = __webpack_public_path__ + "img/Flag_of_Tajikistan.c8b3c494.svg";